import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG5M5F1 (應收帳款調整單沖銷)
// ============================================================

export interface ReverseCandidate {
  fg150_01: string; // 調整單號
  fg150_11: string; // 調整日期
  fg150_12: string; // 部門名稱
  fg150_13: string; // 入單人員名稱
  fg150_14: string; // 單據類別文字
  fg150_15: string; // 幣別代碼
  fg150_16: string; // 調整金額
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwg5m5Api = {
  /** Query AR adjustment order candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwg5m5/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch reversal for selected AR adjustment orders.
   * PWG5M5-VAL-REVERSE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * now rejects any call missing an explicit confirmed:true with 422 + zero
   * DB mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwg504f1's own client.
   */
  async reverse(items: string[], confirmed: boolean = true): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwg5m5/reverse', { items, confirmed });
    return res.data;
  },
};
